module.exports = __webpack_public_path__ + "static/media/baner2.5d9bcebb.jpg";